import { slackConfig } from "./slack"
import { googleCalendarConfig } from "./google-calendar"
import type { ProviderConfig } from "./types"

const REGISTRY: Record<string, ProviderConfig> = {
  slack: slackConfig,
  "google-calendar": googleCalendarConfig,
}

export function getProviderConfig(integrationId: string): ProviderConfig | null {
  return REGISTRY[integrationId] ?? null
}

export type { ProviderConfig, ConfigField, ConfigSection } from "./types"
